import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import {
    IconContainer,
    StatusBannerContainer,
    StatusBannerContent,
    StatusBannerText,
} from './styles';
import getRuntimeConfig from '~/services/runtime-config.service';
import Link from '~/components/common/link';
import ShareFeedbackIcon from '~/assets/icons/ontario-icon-share-feedback.svg';
import { useAuthentication } from '~/components/address-change/hook';
import { useProfileTier } from '~/hooks/useProfileTier';
import { PROFILE_TIERS } from '~/constants/profileTier';
import { useRouter } from 'next/router';

const StatusBanner = () => {
    const { t } = useTranslation('base-layout');
    const [feedbackLink, setFeedbackLink] = useState<string>();
    const { isCXPUser } = useAuthentication();
    const { profileTier } = useProfileTier();
    const router = useRouter();

    const pathnames: Record<string, [string, string]> = {
        '/dashboard': ['dashboard', 'cxpDashboard'],
        '/products/drivers-licence': ['DL', 'driversLicenceDashboard'],
        '/products/photo-card': ['OPC', 'photoCardDashboard'],
    };

    const svc = pathnames[router.pathname]?.[0] ?? 'unknown';
    const cxpuser = profileTier === PROFILE_TIERS.T2 ? 'T2' : isCXPUser ? 'yes' : 'no';

    useEffect(() => {
        getRuntimeConfig().then(runtimeConfig => {
            const suffix = pathnames[router.pathname]?.[1] ?? 'cxpDashboard';
            const link =
                runtimeConfig.environment === 'production'
                    ? t(`statusBanner.productionFeedbackLink.${suffix}`)
                    : t(`statusBanner.uatFeedbackLink.${suffix}`);
            setFeedbackLink(`${link}?cxpuser=${cxpuser}&sts=200&svc=${svc}`);
        });
    }, [t]);

    return (
        <StatusBannerContainer>
            <StatusBannerContent>
                <IconContainer>
                    <ShareFeedbackIcon role="presentation" aria-hidden="true" focusable="false" />
                </IconContainer>
                <StatusBannerText>
                    {t('statusBanner.shareYour')}{' '}
                    <Link href={feedbackLink ?? '#'} openInNewWindow>
                        {t('statusBanner.feedback')}
                    </Link>{' '}
                    {t('statusBanner.helpImprove')}
                </StatusBannerText>
            </StatusBannerContent>
        </StatusBannerContainer>
    );
};

export default StatusBanner;
